import React, { Fragment } from 'react';
import { DI } from 'modules';
import Component from 'components/component';
import Dropdown from 'components/dropdown';
import Tooltip from 'components/tooltip';

import config from 'config';

import BrandingPositionModal from 'components/branding-position';
import BrandingPositionInput from 'components/branding-position/branding-position-input';

export class DownloadSliderInner extends Component {
  static defaultProps = {
    onFormatChange: format => {}
  };

  state = {
    openModal: false
  };

  componentDidMount() {
    this.props.actions.videos.getAvailableFormats(this.props.entity.inner_id, {
      agreement_id: this.props.agreement.id
    });
  }

  togglePositionModal(ev) {
    ev && ev.preventDefault();
    this.setState({
      openModal: !this.state.openModal
    });
  }

  render() {
    const { entity, common, form, allowedPreview } = this.props;
    const { strings } = common;
    const { branding_type } = form;
    const branded = branding_type === 'branded';
    const credit = branding_type === 'credit';

    const formats = this.props.videos.availableFormats.payload[
      branded ? 'branded' : credit ? 'credit' : 'clean'
    ];
    let arrFormats = formats.slice();

    if (allowedPreview.preview_video_download_allowed) {
      arrFormats.splice(3, 0, {
        isPreview: allowedPreview.preview_video_download_allowed
      });
    }

    return (
      <div style={formats.length <= 1 ? { display: 'none' } : {}}>
        <div className="side-popup-line" />
        <div className="side-popup__title">
          {strings['page.video.slider.format']}
        </div>
        <div className="side-buy-format">
          <Dropdown
            autoSelect={formats.length === 1}
            onChange={(e, format) => this.props.onFormatChange(format)}
            placeholder={strings['page.video.slider.choose_format']}
            name="format"
            getTitle={getTitle}
            getValue={getValue}
            headerModificator={['big', 'big-text']}
            items={arrFormats}
            value={form.format || this.props.defaultFormat}
          />
        </div>
        {(branded || credit) && (
          <Fragment>
            <div className="side-popup__title">
              {strings['page.video.slider.branding_position.title']}
              <a
                className="side-popup__title-link"
                href="#"
                onClick={() => this.togglePositionModal()}
              >
                {strings['page.video.slider.branding_position.examples']}
              </a>
            </div>
            <BrandingPositionInput
              name="branding_position"
              value={this.props.form.branding_position}
              worldExclusive={entity.world_exclusive}
              inline={false}
            />
            {this.state.openModal && (
              <BrandingPositionModal
                onClose={() => this.togglePositionModal()}
                position={form.branding_position}
                worldExclusive={entity.world_exclusive}
                exclusive={entity.exclusive && credit}
                save={branding_position => {
                  this.props.updateForm({
                    ...form,
                    branding_position
                  });
                }}
              />
            )}
          </Fragment>
        )}
        {this.props.agreement &&
          this.props.agreement.agreement_type !== 'one_off' && (
            <Fragment>
              <div className="side-popup-line" />
              <Tooltip
                content={strings['page.video.slider.download_project_xml_btn']}
              >
                <a
                  className="btn-bord side-buy-plan__btn"
                  href={`${config.API_HOST}/api/content/video_projects/${entity.id}.xml`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {strings['page.video.slider.download_project_xml_btn']}
                </a>
              </Tooltip>
            </Fragment>
          )}
      </div>
    );
  }
}

function getTitle(format) {
  if (!format) {
    return '360p, mp4';
  }
  if (format.extension === 'mxf') {
    return '1080i, mxf';
  }
  if (format.isPreview) {
    return '360p, screener (free download)';
  }

  switch (format.quality) {
    case 'full_hd':
      return `1080p, ${format.extension}`;
    case 'hd':
      return `720p, ${format.extension}`;
    case 'md':
      return `360p, ${format.extension}`;
    default:
      return null;
  }
}

function getValue(format) {
  if (format.isPreview) {
    return `md;mp4;screener_free`;
  }
  return `${format.quality};${format.extension};${format.file_type}`;
}

export default DI(['videos', 'common'])(DownloadSliderInner);
